module.exports = __webpack_public_path__ + "img/W-V06.8b8a2224.jpg";